// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewItemList_container__2XUML","header":"ReviewItemList_header__2kdwF","reviewItem":"ReviewItemList_reviewItem__1E52_"};